import {
	DEFAULT_WORKFLOW_SHORTCUT_ICON,
	resolveWorkflowShortcutImage,
} from '@/utils/workflowShortcutIcons';

const groupAppsDefault = [
	{
		id: "operation",
		name: "Vận hành",
		apps: [
			{
				id: "workflows",
				type: "item",
				icon: "nav_ycsb",
				title: "Quy trình",
				image: require('@/assets/icons/YCSB.png'),
				routeName: "workflows.user_task",
				customImage: true,
				have_bought: true,
				incomming: false
			},
			{
				id: "manage",
				type: "item",
				icon: "users-cog",
				title: "Cài đặt công ty",
				image: require('@/assets/icons/QLNB.png'),
				routeName: "staff.index",
				exact: true,
				customImage: false,
				have_bought: true,
				incomming: false,
				dropdown: [
					{
						id: "manage",
						type: "item",
						icon: "users-cog",
						title: "Cài đặt công ty",
						image: require('@/assets/icons/QLNB.png'),
						dropdown: [
							{
								id: "staff",
								type: "item",
								title: "Tài khoản",
								routeName: "staff.index",
								exact: true
							},
							{
								id: "role",
								type: "item",
								title: "Phân quyền",
								routeName: "role.index",
								exact: true
							},
							{
								id: "branch",
								title: "Chi nhánh",
								routeName: "branch.index",
								exact: true
							},
							{
								id: "position",
								title: "Chức vụ",
								routeName: "position.index",
								exact: true
							},
							{
								id: "appraiser-company",
								title: "Thông tin công ty",
								routeName: "appraiser-company.index",
								exact: true
							},
							{
								id: "bank-account",
								title: "Tài khoản ngân hàng",
								routeName: "bank_account.index",
								exact: true
							}
						],
						exact: true,
						customImage: false
					},
				],
			},
			{
				id: "digital_signature_requests",
				type: "item",
				icon: "file-signature",
				title: "Yêu cầu ký số",
				image: require('@/assets/icons/CSM.png'),
				routeName: "profile.digital_signature_requests",
				have_bought: true,
				incomming: false,
			},
			{
				id: "digital_signature_history",
				type: "item",
				icon: "history",
				title: "Lịch sử ký số",
				image: require('@/assets/icons/QLDT.png'),
				routeName: "profile.digital_signature_history",
				have_bought: true,
				incomming: false,
			},
		]
	},
];

const fallbackDefaultAppConfig = [
	{ group: 'operation', id: 'workflows' },
	{ group: 'operation', id: 'manage' },
];

const ALWAYS_HIDDEN_APP_IDS = [
	'quyhoach',
	'dashboard',
	'finance',
	'customer',
	'customer_group_first',
	'customer_group',
	'customer_private',
	'tcct',
	'certification_asset',
	'warehouse',
	'price_estimates',
	'appraise',
	'appraise-law',
	'appraise-other',
	'appraisal-construction',
	'building',
	'element',
	'apartment',
	'api_connection',
	'in_depth_report',
	'tttt',
	'workFlowConfig',
	'working-hours',
];

const parseArrayEnv = (value) => {
	if (Array.isArray(value)) {
		return value;
	}
	if (typeof value === 'string') {
		try {
			const parsed = JSON.parse(value);
			return Array.isArray(parsed) ? parsed : null;
		} catch (error) {
			return null;
		}
	}
	return null;
};

const parseBooleanEnv = (value, defaultValue = false) => {
	if (typeof value === 'boolean') {
		return value;
	}
	if (typeof value === 'string') {
		const normalized = value.trim().toLowerCase();
		if (normalized === 'true') {
			return true;
		}
		if (normalized === 'false') {
			return false;
		}
	}
	return defaultValue;
};

const parseObjectEnv = (value) => {
	if (value && typeof value === 'object' && !Array.isArray(value)) {
		return value;
	}
	if (typeof value === 'string') {
		try {
			const parsed = JSON.parse(value);
			if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
				return parsed;
			}
		} catch (error) {
			return null;
		}
	}
	return null;
};

const buildWorkflowShortcutId = (workflowId) => `workflow-shortcut-${workflowId}`;

const normalizeWorkflowShortcuts = (value) => {
	const parsed = parseArrayEnv(value);
	if (!Array.isArray(parsed)) {
		return [];
	}

	return parsed
		.map((item) => {
			if (!item || typeof item !== 'object') {
				return null;
			}

			const workflowId = String(
				item.workflowId ?? item.workflow_id ?? item.id ?? ''
			).trim();
			const title = String(item.title ?? item.name ?? '').trim();

			if (!workflowId || !title) {
				return null;
			}

			return {
				id: buildWorkflowShortcutId(workflowId),
				type: 'item',
				icon: item.icon || 'nav_ycsb',
				title,
				image: resolveWorkflowShortcutImage(
					item.shortcut_icon || item.shortcutIcon,
					item.shortcut_icon_image || item.shortcutIconImage,
					item.shortcut_icon_type || item.shortcutIconType
				),
				shortcutIcon: item.shortcut_icon || item.shortcutIcon || DEFAULT_WORKFLOW_SHORTCUT_ICON,
				shortcutIconImage: item.shortcut_icon_image || item.shortcutIconImage || '',
				shortcutIconType: item.shortcut_icon_type || item.shortcutIconType || '',
				routeName: 'workflows.detail',
				routeQuery: {
					id: workflowId,
					name: title,
					...(item.routeQuery && typeof item.routeQuery === 'object' ? item.routeQuery : {}),
				},
				routeParams: item.routeParams && typeof item.routeParams === 'object' ? item.routeParams : {},
				customImage: true,
				have_bought: item.have_bought ?? true,
				incomming: item.incomming ?? false,
			};
		})
		.filter(Boolean);
};

const cloneAppNode = (node) => {
	const cloned = { ...node };
	if (Array.isArray(node.dropdown)) {
		const dropdownClone = node.dropdown.map((child) => cloneAppNode(child));
		if (dropdownClone.length > 0) {
			cloned.dropdown = dropdownClone;
		}
	}
	return cloned;
};

const filterAppNodes = (nodes, allowedIds, hiddenIdsSet) => {
	if (!Array.isArray(nodes)) {
		return [];
	}
	return nodes
		.filter((item) => {
			if (hiddenIdsSet && hiddenIdsSet.has(item.id)) {
				return false;
			}
			return !allowedIds || allowedIds.includes(item.id);
		})
		.map((item) => {
			const cloned = { ...item };
			if (Array.isArray(item.dropdown)) {
				const filteredDropdown = filterAppNodes(item.dropdown, allowedIds, hiddenIdsSet);
				if (filteredDropdown.length > 0) {
					cloned.dropdown = filteredDropdown;
				} else {
					delete cloned.dropdown;
				}
			}
			return cloned;
		});
};

const findAppInNodes = (nodes, appId) => {
	if (!Array.isArray(nodes)) {
		return null;
	}
	for (const node of nodes) {
		if (node.id === appId) {
			return node;
		}
		if (Array.isArray(node.dropdown)) {
			const found = findAppInNodes(node.dropdown, appId);
			if (found) {
				return found;
			}
		}
	}
	return null;
};

const resolveAppFromGroups = (groups, groupId, appId) => {
	const targets = groupId ? groups.filter((group) => group.id === groupId) : groups;
	for (const group of targets) {
		const found = findAppInNodes(group.apps, appId);
		if (found) {
			return cloneAppNode(found);
		}
	}
	return null;
};

const applyHaveBoughtOverrides = (nodes, boughtMap, allowedBoughtSet) => {
	if (!Array.isArray(nodes)) {
		return [];
	}
	return nodes.map((node) => {
		const cloned = { ...node };
		if (
			boughtMap &&
			Object.prototype.hasOwnProperty.call(boughtMap, cloned.id)
		) {
			cloned.have_bought = !!boughtMap[cloned.id];
		} else if (allowedBoughtSet instanceof Set) {
			cloned.have_bought = allowedBoughtSet.has(cloned.id);
		}
		if (Array.isArray(node.dropdown)) {
			const dropdownClone = applyHaveBoughtOverrides(
				node.dropdown,
				boughtMap,
				allowedBoughtSet
			);
			if (dropdownClone.length > 0) {
				cloned.dropdown = dropdownClone;
			}
		}
		return cloned;
	});
};

const buildGroupApps = (
	groups,
	allowedGroupIds,
	allowedChildrenMap,
	boughtMap,
	showAllApps,
	hiddenIdsSet,
	workflowShortcutApps = []
) => {
	const baseGroups = Array.isArray(allowedGroupIds) && allowedGroupIds.length > 0
		? groups.filter((group) => allowedGroupIds.includes(group.id))
		: groups;

	return baseGroups.map((group) => {
		const configuredChildren = Array.isArray(allowedChildrenMap && allowedChildrenMap[group.id])
			? [...allowedChildrenMap[group.id]]
			: null;
		const groupApps = group.id === 'operation' && workflowShortcutApps.length > 0
			? (() => {
				const operationApps = [...group.apps];
				const insertIndex = operationApps.findIndex((item) => item.id === 'workflows');
				if (insertIndex === -1) {
					return [...workflowShortcutApps, ...operationApps];
				}
				operationApps.splice(insertIndex + 1, 0, ...workflowShortcutApps);
				return operationApps;
			})()
			: group.apps;
		if (configuredChildren && group.id === 'operation' && workflowShortcutApps.length > 0) {
			workflowShortcutApps.forEach((shortcut) => {
				if (!configuredChildren.includes(shortcut.id)) {
					configuredChildren.push(shortcut.id);
				}
			});
		}
		const allowedChildren = !showAllApps ? configuredChildren : null;
		const allowedBoughtSet = showAllApps && Array.isArray(configuredChildren)
			? new Set(configuredChildren)
			: null;
		const filteredApps = filterAppNodes(groupApps, allowedChildren, hiddenIdsSet);
		return {
			...group,
			apps: applyHaveBoughtOverrides(filteredApps, boughtMap, allowedBoughtSet),
		};
	});
};

const buildDefaultApps = (groups, configEntries, fallbackEntries) => {
	const entries = Array.isArray(configEntries) && configEntries.length > 0 ? configEntries : fallbackEntries;
	const resolved = [];
	const seen = new Set();
	entries.forEach((entry) => {
		if (!entry) {
			return;
		}
		let groupId;
		let appId;
		if (typeof entry === 'string') {
			appId = entry;
		} else if (typeof entry === 'object') {
			appId = entry.id || entry.appId;
			groupId = entry.group || entry.groupId;
		}
		if (!appId) {
			return;
		}
		const key = `${groupId || ''}:${appId}`;
		if (seen.has(key)) {
			return;
		}
		const app = resolveAppFromGroups(groups, groupId, appId);
		if (app) {
			resolved.push(app);
			seen.add(key);
		}
	});
	return resolved;
};

const envDefaultAppsConfig = parseArrayEnv(process.env.default_apps);
const envGroupIds = parseArrayEnv(process.env.group_apps);
const envChildrenConfig = parseObjectEnv(process.env.group_app_children);
const envBoughtConfig = parseObjectEnv(process.env.group_app_bought);
const envShowAllApps = parseBooleanEnv(process.env.show_all_group_apps, true);
const envHiddenApps = parseArrayEnv(process.env.hidden_apps);
const workflowShortcutApps = normalizeWorkflowShortcuts(process.env.workflow_shortcuts);
const hiddenAppIdsSet = new Set([
	...ALWAYS_HIDDEN_APP_IDS,
	...(Array.isArray(envHiddenApps) ? envHiddenApps : []),
]);

const groupApps = buildGroupApps(
	groupAppsDefault,
	envGroupIds,
	envChildrenConfig || {},
	envBoughtConfig || {},
	envShowAllApps,
	hiddenAppIdsSet,
	workflowShortcutApps
);
const defaultApps = [...workflowShortcutApps, ...buildDefaultApps(groupApps, envDefaultAppsConfig, fallbackDefaultAppConfig)]
	.filter((app, index, apps) => app && apps.findIndex((candidate) => candidate.id === app.id) === index);

export { groupAppsDefault, groupApps, defaultApps };
